import { useEffect, useState } from "react";
import { MESSAGE_TARGET_FILTER } from "../../constants/menus";
import moment from "moment";
import { getMessagePrice, range } from "../../libs/helper";
import SuspensePopup from "../SuspensePopup";
import {Button, CalendarBar, Checkbox, QuestionTooltip, RadioGroup, Tab, Toggle} from "omoplay";
import {aiRecommendedUsers, getExpectedCustomerCount, getUseBrandMsg, getMessagePrices} from "../../api/message/volatility-message.api";
import InputGroup from "../form/InputGroup";
import TargetMessageForm from "./TargetMessageForm";
import {getAllSpots} from "../../api/spot/spot.api";
import {getRegionTree} from "../../api/region/region.api";
import {getCountExpectedFriend} from "../../api/moment/moment.api";
import TreeChoiceForm from "../form/TreeChoiceForm";
import {useRecoilValue} from "recoil";
import {accountSelector, channelSelector} from "../../store/selector/selector";
import {channelPermissions, hasAdminGrant} from "../../libs/permissions";

export const MessageTargetSetting = ({id, selectedTargetFilters, reservedDate, isSendMoment, useBrandMsg,
                                         onChangeTargetType, onChangeTargetFilters, messageData,
                                         onChangeSendMoment, onChangeCustomerCnt, onChangeReservedDate, onChangeAdult,
                                         selectUserIds, onChangeSelectUserIds, countAllFriend, onChangeSendFriend,
                                     onUseBrandMsg}) => {
    // 🔴 단가 하드코딩(22) 제거 — 정산이 쓰는 정가표(billing_catalog)와 갈라진다.
    //    구 화면이지만 아직 라우팅되어 있어(`/volatility-message/edit`) 같은 소스를 쓰게 맞춘다.
    const [messagePrices, setMessagePrices] = useState({});
    useEffect(() => { getMessagePrices().then(setMessagePrices) }, []);

    const account = useRecoilValue(accountSelector)
    const channel = useRecoilValue(channelSelector)
    // 판정은 `libs/permissions.js` 한 곳에서 한다 — 종전 `permissions?.[0]?.grant` 는
    // 서버 조회에 `ORDER BY` 가 없어 **어느 권한 행이 [0] 인지가 DB 순서에 달려** 있었다.
    const permissions = channelPermissions(account, channel)
    const isAdmin = hasAdminGrant(permissions)

    const [testMessagePopup, setTestMessagePopup] = useState(false)
    const [customerCount, setCustomerCount] = useState(selectUserIds?.length ?? 0)
    const [filterTargetType, setFilterTargetType] = useState(selectedTargetFilters == null || (typeof selectedTargetFilters === 'object' && !Array.isArray(selectedTargetFilters) && Object.keys(selectedTargetFilters).length === 0) ? 'total' : 'filter')
    const [countFriend, setCountFriend] = useState(countAllFriend)
    const [targetFilters, setTargetFilters] = useState(MESSAGE_TARGET_FILTER)
    const [enabledBrandMsg, setEnabledBrandMsg] = useState(false)

    const tabs = [
        {label: "전체", value: "total", selected: filterTargetType === "total", style: {flex: 1}},
    ]

    if (isAdmin) {
        tabs.push(
            {label: "AI 분석", value: "ai", selected: filterTargetType === "ai", style: {flex: 1}},
            {label: "조건 필터링", value: "filter", selected: filterTargetType === "filter", style: {flex: 1}},
            {label: "회원이 아닌 대상", value: "moment", selected: filterTargetType === "moment", style: {flex: 1}})
    }
    const type = messageData.type

    useEffect(() => {
        getUseBrandMsg().then(({data}) => {
            setEnabledBrandMsg(data)
        })
        // 주소(배송지) 필터 지역 트리를 API로 채움(하드코딩 제거). project 주입과 동일 패턴.
        getRegionTree().then(({data}) => {
            const addressIndex = MESSAGE_TARGET_FILTER.findIndex((item) => item.value === "address")
            if (addressIndex !== -1) {
                MESSAGE_TARGET_FILTER[addressIndex].data = data ?? []
                setTargetFilters([...MESSAGE_TARGET_FILTER])
            }
        })
    }, []);

    useEffect(() => {
        handleReserveDateChange("min", reservedDate.min % 5 !== 0 ? "00" : reservedDate.min)
        if (countAllFriend === 0) {
          getCountExpectedFriend().then(({data}) => {
            setCountFriend(data)
            if (isSendMoment) {
              onChangeSendFriend(data)
            }
          })
        }
    }, [isSendMoment])

    useEffect(() => {
        setCustomerCount(0)
        if (filterTargetType === "total" || filterTargetType === "filter" || filterTargetType === "ai") {
          getExpectedCustomerCount(id, filterTargetType, selectedTargetFilters, useBrandMsg).then(({data}) => {
            setCustomerCount(data)
            onChangeCustomerCnt(data)
          })
          if (filterTargetType === "filter") {
              if (targetFilters.find(filter => filter.value === "entry_point").data.length === 0) {
                  getAllSpots().then(({data}) => {
                      setTargetFilters(MESSAGE_TARGET_FILTER.map((filter) => {
                              if (filter.value === "entry_point") {
                                  return {
                                      ...filter, data: data.map(value => ({value: value.id, label: value.name}))
                                  }
                              } else {
                                  return filter
                              }
                          }
                      ))
                  })
              }
          }
        } else if (filterTargetType === "moment") {
            setCustomerCount(0)
            onChangeCustomerCnt(0)
        }
    }, [selectedTargetFilters, filterTargetType, useBrandMsg])

    const handleReserveDateChange = (type, value) => {
        const updateValue = { ...reservedDate }
        if (type === "date") {
          value.startDate = moment(value).format("YYYY-MM-DD")
          value.endDate = moment(value).format("YYYY-MM-DD")
        }
        updateValue[type] = value;
        onChangeReservedDate(updateValue)
    }


    return (
      <div className="flex-col gap-2">
        <InputGroup label="대상 조건 설정" description={(
            <div className="flex-align-center justify-between">
              <div>메시지 발송 대상의 조건을 설정해 주세요.</div>
              <Button variants="outlined" value="테스트 발송" onClick={() => setTestMessagePopup(true)} />
            </div>)}
        >
          <div className="flex-col gap-4">
            <label className="text-md font-semibold text-gray-900 relative">
              누구에게 발송하시겠습니까?
            </label>
            <Tab items={tabs}
                 variants="sub"
                 onChanged={(item) => {
                   const value = item.value
                   if (value === "total") {
                     setTargetFilters(MESSAGE_TARGET_FILTER)
                     onChangeTargetFilters({})
                     onChangeSelectUserIds(null)
                   } else if (value === "filter") {
                     onChangeSelectUserIds(null)
                     onChangeSendFriend?.(0)
                   } else if (value === "target") {
                     setCustomerCount(selectUserIds?.length ?? 0)
                     onChangeSendFriend?.(0)
                   }
                   setFilterTargetType(value)
                   onChangeTargetType(value)
                 }}
            />
            <div className="flex-col gap-4">
              <div className="flex-col">
                {filterTargetType === "filter" && (
                    <TreeChoiceForm targetFilters={targetFilters} selectedTargetFilters={
                        Object.entries(selectedTargetFilters).flatMap(([category, labels]) =>
                            labels.map(label => ({
                                category,
                                label,
                                value: label
                            }))
                        )
                    }
                                    onChangeTargetFilters={onChangeTargetFilters} />
                )}
                {
                    filterTargetType === "ai" && (
                        <div className="flex-align-center gap-4 justify-end p-4">
                          <div>
                            <div>AI가 메시지 내용을 판단해 자동으로 고객 리스트를 추천 합니다.</div>
                              {/*
                            {
                              id == null && (<div className="text-red-500">*임시 저장 상태에서만 분석이 가능합니다.</div>)
                            }
                            */}
                              <div className="text-red-500">*현재 사용이 불가합니다.</div>
                          </div>
                          <Button variants="ai" value="AI 분석하기" disabled={true} onClick={() => {
                            if (window.confirm("현재 메시지 내용을 저장하고 분석을 시작합니다.\n분석이 종료되기 전까지 메시지를 수정할 수 없습니다.")) {
                              aiRecommendedUsers(id, messageData).then(({data}) => {
                                setCustomerCount(data.length)
                                onChangeCustomerCnt(data.length)
                              })
                              window.location.href = "/volatility-message"
                            }
                          }} />
                        </div>
                    )
                }
                {
                    filterTargetType === "target" && (
                        <TargetMessageForm id={id} selectUserIds={selectUserIds ?? []}
                                           messageData={messageData}
                                           onSelectedUserIds={(userIds) => {
                                             onChangeSelectUserIds(userIds)
                                             setCustomerCount([...new Set(userIds)].length)
                                             onChangeCustomerCnt([...new Set(userIds)].length)
                                          }} />
                    )
                }
                {
                  filterTargetType !== "moment" && (
                        <div className="bg-gray-100 p-4 flex-col gap-4">
                            <div className="flex-align-center gap-2">
                                <Checkbox item={{label: "브랜드 메시지 포함하기", value: "brand"}}
                                          disabled={!enabledBrandMsg}
                                          checked={useBrandMsg}
                                          onChecked={(checked) => {
                                              onUseBrandMsg(checked)
                                          }}
                                />
                                <div>
                                    <QuestionTooltip>
                                        <div>
                                            <div className="text-red-500">채널을 차단하지 않은 고객에게 모두 발송합니다.</div>
                                            <div>브랜드 메시지를 보내시려면 오모플레이에 문의 해주세요.</div>
                                            <div className="text-[20px]">조건</div>
                                            <div className="text-primary">친구 수 5만명 이상</div>
                                            <div className="text-primary">최근 3개월 알림톡 전송 여부</div>
                                            <div className="text-primary">마케팅 수신동의 증빙 자료 제출</div>
                                        </div>
                                    </QuestionTooltip>
                                </div>
                            </div>
                          <div className="flex items-center gap-4">
                            <div className="rounded border border-gray-300 text-center w-[286px]">
                              <div className="text-gray-400 py-1.5 text-sm border-b border-gray-300">
                                예상 고객 수 (발송 건 수)
                              </div>
                              <div className="bg-white py-2 font-semibold text-center">
                                {customerCount?.toLocaleString()}명 (건)
                              </div>
                            </div>
                            <div className="w-6 h-6 bg-white rounded flex justify-center items-center text-gray-500">
                              X
                            </div>
                            <div className="rounded border border-gray-300 text-center w-[118px]">
                              <div className="text-gray-400 py-1.5 text-sm border-b border-gray-300">
                                메시지 단가
                              </div>
                              <div className="py-2 font-semibold">
                                {getMessagePrice(type)}원
                              </div>
                            </div>
                            <div className="w-6 h-6 bg-white rounded flex justify-center items-center text-gray-500">
                              =
                            </div>
                            <div className="rounded border border-gray-300 text-center w-[326px]">
                              <div className="text-gray-400 py-1.5 text-sm border-b border-gray-300">
                                총 예상 발송 비용
                              </div>
                              <div className="bg-white py-2 font-semibold flex justify-center gap-2 text-indigo-600">
                                <>
                                  <div className="bg-indigo-100 w-6 h-6 flex justify-center items-center  rounded">
                                    ₩
                                  </div>
                                  {Math.floor(
                                      customerCount *
                                      getMessagePrice(type)
                                  ).toLocaleString()}
                                  원
                                </>
                              </div>
                            </div>
                          </div>
                          <div>
                            <p className="text-gray-500 text-sm my-4 text-[12px]">
                              * ‘예상 고객 수’는 발송을 시도하는 고객 수를 의미하고, 실제 발송되는 고객 수와는 차이가 있을 수 있습니다.
                            </p>
                            <p className="text-gray-500 text-sm my-4 text-[12px]">
                              * 메시지 발송 등록 시 과금된 비용과 실발송 후의 차액은 발생할 수 있으며, 발송되지 않은 건은 일정 시간 후 크레딧으로 반환됩니다.
                            </p>
                          </div>
                        </div>
                    )
                }
                {
                    (isAdmin && filterTargetType === "total") && (
                        <div className="flex-col gap-2 mt-[20px]">
                          <div className="flex gap-2">
                            <div className="font-semibold">회원이 아닌 카카오 친구 포함하기</div>
                            <Toggle disabled={countFriend <= 10 || messageData.coupon || (messageData.carousels?.length > 0 && messageData.carousels[0].attachment.coupon)} value={countAllFriend > 0 || isSendMoment}
                                    onToggle={(flag) => {
                                      onChangeSendFriend(flag ? countFriend : 0)
                                      onChangeSendMoment(flag)
                                    }}
                            />
                            {
                                countFriend <= 10 && (<div className="text-red-500">* 10명 이하는 전송할 수 없습니다.</div>)
                            }
                              {
                                  (messageData.coupon || (messageData.carousels?.length > 0 && messageData.carousels[0].attachment.coupon)) && (<div className="text-red-500">* 쿠폰 타입이 포함되어 있으면 전송할 수 없습니다.</div>)
                              }
                          </div>
                          <div className="bg-gray-100 p-4 flex-col">
                            <div className="flex items-center gap-4">
                              <div className="rounded border border-gray-300 text-center w-[286px]">
                                <div className="text-gray-400 py-1.5 text-sm border-b border-gray-300">
                                  예상 고객 수 (발송 건 수)
                                </div>
                                <div className="bg-white py-2 font-semibold text-center">
                                  {countFriend.toLocaleString()}명 (건)
                                </div>
                              </div>
                              <div className="w-6 h-6 bg-white rounded flex justify-center items-center text-gray-500">
                                X
                              </div>
                              <div className="rounded border border-gray-300 text-center w-[118px]">
                                <div className="text-gray-400 py-1.5 text-sm border-b border-gray-300">
                                  메시지 단가
                                </div>
                                <div className="py-2 font-semibold">
                                  22원
                                </div>
                              </div>
                              <div className="w-6 h-6 bg-white rounded flex justify-center items-center text-gray-500">
                                =
                              </div>
                              <div className="rounded border border-gray-300 text-center w-[326px]">
                                <div className="text-gray-400 py-1.5 text-sm border-b border-gray-300">
                                  총 예상 발송 비용
                                </div>
                                <div className="bg-white py-2 font-semibold flex justify-center gap-2 text-indigo-600">
                                  <>
                                    <div className="bg-indigo-100 w-6 h-6 flex justify-center items-center  rounded">
                                      ₩
                                    </div>
                                    {(countFriend * (messagePrices['FI'] ?? 0)).toLocaleString()}원
                                  </>
                                </div>
                              </div>
                            </div>
                            <div>
                              <p className="text-gray-500 text-sm my-4 text-[12px]">
                                * ‘예상 고객 수’는 발송을 시도하는 고객 수를 의미하고, 실제 발송되는 고객 수와는 차이가 있을 수 있습니다.
                              </p>
                              <p className="text-gray-500 text-sm my-4 text-[12px]">
                                * 메시지 발송등록 시 과금된 비용과 실발송 후의 차액은 발생할 수 있으며, 발송되지 않은 건은 일정 시간 후 크레딧으로 반환됩니다.
                              </p>
                            </div>
                          </div>
                        </div>
                    )
                }
                {
                    filterTargetType === "moment" && (
                        <div className="flex-col gap-2 mt-[20px]">
                          <div className="flex gap-2">
                            <div className="font-semibold">회원이 아닌 카카오 친구에게만 보내기</div>
                            <Toggle disabled={countFriend <= 10 || messageData.coupon || (messageData.carousels?.length > 0 && messageData.carousels[0].attachment.coupon)} value={countAllFriend > 0 || isSendMoment} onToggle={(flag) => {
                              onChangeSendFriend(flag ? countFriend : 0)
                              onChangeSendMoment(flag)
                            }} />
                            {
                                countFriend <= 10 && (<div className="text-red-500">* 10명 이하는 전송할 수 없습니다.</div>)
                            }
                            {
                                (messageData.coupon || (messageData.carousels?.length > 0 && messageData.carousels[0].attachment.coupon)) && (<div className="text-red-500">* 쿠폰 타입이 포함되어 있으면 전송할 수 없습니다.</div>)
                            }
                          </div>
                          <div className="bg-gray-100 p-4 flex-col">
                            <div className="flex items-center gap-4">
                              <div className="rounded border border-gray-300 text-center w-[286px]">
                                <div className="text-gray-400 py-1.5 text-sm border-b border-gray-300">
                                  예상 고객 수 (발송 건 수)
                                </div>
                                <div className="bg-white py-2 font-semibold text-center">
                                  {countFriend.toLocaleString()}명 (건)
                                </div>
                              </div>
                              <div className="w-6 h-6 bg-white rounded flex justify-center items-center text-gray-500">
                                X
                              </div>
                              <div className="rounded border border-gray-300 text-center w-[118px]">
                                <div className="text-gray-400 py-1.5 text-sm border-b border-gray-300">
                                  메시지 단가
                                </div>
                                <div className="py-2 font-semibold">
                                  20원
                                </div>
                              </div>
                              <div className="w-6 h-6 bg-white rounded flex justify-center items-center text-gray-500">
                                =
                              </div>
                              <div className="rounded border border-gray-300 text-center w-[326px]">
                                <div className="text-gray-400 py-1.5 text-sm border-b border-gray-300">
                                  총 예상 발송 비용
                                </div>
                                <div className="bg-white py-2 font-semibold flex justify-center gap-2 text-indigo-600">
                                  <>
                                    <div className="bg-indigo-100 w-6 h-6 flex justify-center items-center  rounded">
                                      ₩
                                    </div>
                                    {(countFriend * (messagePrices['FI'] ?? 0)).toLocaleString()}원
                                  </>
                                </div>
                              </div>
                            </div>
                            <div>
                              <p className="text-gray-500 text-sm my-4 text-[12px]">
                                * ‘예상 고객 수’는 발송을 시도하는 고객 수를 의미하고, 실제 발송되는 고객 수와는 차이가 있을 수 있습니다.
                              </p>
                              <p className="text-gray-500 text-sm my-4 text-[12px]">
                                * 메시지 발송등록 시 과금된 비용과 실발송 후의 차액은 발생할 수 있으며, 발송되지 않은 건은 일정 시간 후 크레딧으로 반환됩니다.
                              </p>
                            </div>
                          </div>
                        </div>
                    )
                }
              </div>
            </div>
          </div>
        </InputGroup>
        <InputGroup label={"연령 인증 메시지"}>
          <div className="flex-col justify-center gap-2">
            <RadioGroup
                items={[
                  {
                    label: "선택안함",
                    value: "N"
                  },
                  {
                    label: "선택함",
                    value: "Y"
                  }
                ]}
                initChecked={messageData.adult ?? "N"}
                value={messageData.adult}
                onSelected={(value) => {
                  onChangeAdult(value)
                }}
            />
            <div>
              <div className="font-12px">연령인증 전까지 채팅방 메시지에 커버가 씌워지며, 20세 이상 성인만 내용을 확인할 수 있습니다.</div>
              <div className="font-12px">20세 이상에게 적합한 내용을 담고 있다면 필수 선택해주세요.</div>
              <div className="font-12px">예: 주류, 청소년 이용불가 게임 및 영화 등</div>
            </div>
          </div>
        </InputGroup>
        <InputGroup label="발송 날짜/시간 설정">
          <div className="flex gap-2 my-2 items-center">
            <div className="flex border-gray-200 border rounded">
              <CalendarBar minDate={new Date()} multiple={false} initDate={{
                startDate: moment(reservedDate.date.startDate).toDate(),
                endDate: moment(reservedDate.date.endDate).toDate()
              }} onConfirm={(dateProps) => {
                handleReserveDateChange("date", dateProps.startDate);
              }} />
            </div>
            <select
                className="w-100 bg-white border border-gray-200 text-gray-900 rounded focus:ring-indigo-500 focus:border-indigo-500 block p-2 h-[45px]"
                value={reservedDate.hour}
                onChange={(e) =>
                    handleReserveDateChange("hour", e.target.value)
                }
            >
              {range(13, 8).map((time) => {
                return (
                    <option value={String(time).padStart(2, "0")}>
                      {String(time).padStart(2, "0")}시
                    </option>
                );
              })}
            </select>
            <select
                className="w-100 bg-white border border-gray-200 text-gray-900 rounded focus:ring-indigo-500 focus:border-indigo-500 block p-2 h-[45px]"
                value={reservedDate.min}
                onChange={(e) => {
                  handleReserveDateChange("min", e.target.value)
                }}
            >
              {Array.from({ length: 12 }, (_, i) => i * 5).map((time) => {
                if (reservedDate.hour === "20" && time > 55) {
                  return
                }
                return (
                    <option value={String(time).padStart(2, "0")}>
                      {String(time).padStart(2, "0")}분
                    </option>
                );
              })}
            </select>
          </div>
          <div className="w-full rounded px-4 py-0.5">
            <p className="text-[12px] my-2">
              * 20:55부터 08:00까지는 메시지 수신이 불가하여 <span className="text-[12px] text-primary">익일 오전 08:00 이후에 메시지를 받게 됩니다.</span>
            </p>
          </div>
        </InputGroup>
        <SuspensePopup
            title={"테스트 발송하기"}
            visible={testMessagePopup}
            style={{width: "1000px"}}
            onClose={() => setTestMessagePopup(false)}
        >
          <TargetMessageForm id={id}
                             isTest={true}
                             isBrandMsg={useBrandMsg}
                             messageData={messageData}
                             onSelectedUserIds={() => {}}
                             selectUserIds={selectUserIds ?? []}
                             onSendMessage={() => setTestMessagePopup(false)}

          />
        </SuspensePopup>
      </div>
    );
};

export default MessageTargetSetting;
